import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Events from '@/hooks/events';
import actions from '../constants';

const useSwitchEntityFilter = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ entity }) => handler({
    type: actions.SWITCH_ENTITY_FILTER, category, code, entity,
  }), [category, code]);
};

const useUpdateAuditsFilter = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ filter, value }) => handler({
    type: actions.UPDATE_AUDITS_FILTER, category, code, filter, value,
  }), [category, code]);
};

const useToggleAuditsColumnOrderBy = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ orderByColumn }) => handler({
    type: actions.TOGGLE_AUDITS_COLUMN_ORDER_BY, category, code, orderByColumn,
  }), [category, code]);
};

export default {
  useFetchAudits: (category, { code }) => Events.useFetchByCode(actions.FETCH_AUDITS, category, code),
  useRefreshAudits: (category, { code }) => Events.useRefreshByCode(actions.REFRESH_AUDITS, category, code),
  useSwitchEntityFilter,
  useToggleAuditsColumnOrderBy,
  useToggleAuditsSingleSorting: (category, { code }) => Events.useDispatchByCode(
    actions.TOGGLE_AUDITS_SINGLE_SORTING,
    category,
    code,
  ),
  useUpdateAuditsFilter,
};
